import type { HTMLAttributes } from "react";
import "./card.css";

type Props = HTMLAttributes<HTMLDivElement>;

export function Card({ className, ...rest }: Props) {
  return <div className={className ? `g-card ${className}` : "g-card"} {...rest} />;
}
